import { File, Paths } from 'expo-file-system';
import { NativeStackHeaderProps, Stack, useRouter } from 'expo-router';
import { shareAsync } from 'expo-sharing';
import { MyVaroContext } from 'features/myVaro/provider/MyVaroContextProvider';
import React, { useContext } from 'react';
import { Share, StyleSheet, View } from 'react-native';
import PdfViewer from 'shared/components/PdfRenderer/PdfViewer';
import IconButton from 'shared/components/vxl/icon/IconButton/IconButton';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import { isWeb } from 'shared/constants/platform';
import { logBreadcrumb } from 'shared/utils/sentry/sentry';

const AccountStatementPDF = () => {
  const router = useRouter();
  const {
    selectedMonthScreenTitle,
    accountStatementPDFId,
    setAccountStatementPDFId,
    accountStatementPDFTitle,
    setAccountStatementPDFTitle,
  } = useContext(MyVaroContext);

  const onShare = async () => {
    try {
      if (isWeb) {
        await Share.share({
          message: accountStatementPDFId ? accountStatementPDFId : '',
        });
      } else {
        if (accountStatementPDFId) {
          const destination = new File(
            Paths.cache,
            `${accountStatementPDFTitle}.pdf`,
          );
          const downloadedFile = await File.downloadFileAsync(
            accountStatementPDFId,
            destination,
            { idempotent: true },
          );
          await shareAsync(downloadedFile.uri);
        }
      }
    } catch (error) {
      logBreadcrumb({
        level: 'error',
        message: 'AccountStatementPDF onShare error: ' + error,
      });
    }
  };

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          title: selectedMonthScreenTitle,
          headerShown: true,
          headerBackVisible: true,
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar
              {...props}
              primaryOnPress={() => {
                setAccountStatementPDFId?.('');
                setAccountStatementPDFTitle?.('');
                router.back();
              }}
              trailingAccessories={
                <IconButton
                  iconKey="SHARE"
                  iconButtonAccessibilityLabel="SHARE"
                  iconOnPress={onShare}
                />
              }
            />
          ),
        }}
      />
      {accountStatementPDFId ? <PdfViewer url={accountStatementPDFId} /> : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexGrow: 1,
  },
});

export default AccountStatementPDF;
